import { useState } from 'react'

import { DeserializedSavedFilter } from 'api/AccountActivityAPI/types'
import { FilterGroup } from 'utils/filters'

export default function useSavedFilterEditModal() {
  const [showSavedFilterModal, setShowSavedFilterModal] = useState<boolean>(false)
  const [editableFilterGroups, setEditableFilterGroups] = useState<FilterGroup[]>([])
  const [editableSavedFilter, setEditableSavedFilter] = useState<
    DeserializedSavedFilter | undefined
  >(undefined)

  const onOpenEditModal = (filter?: DeserializedSavedFilter, editableGroups?: FilterGroup[]) => {
    setShowSavedFilterModal(true)
    setEditableSavedFilter(filter)
    setEditableFilterGroups(editableGroups || [])
  }

  const onOpenNewModal = () => {
    setShowSavedFilterModal(true)
    setEditableSavedFilter(undefined)
    setEditableFilterGroups([])
  }

  const onCloseModal = () => {
    setShowSavedFilterModal(false)
    setEditableSavedFilter(undefined)
    setEditableFilterGroups([])
  }

  return {
    showSavedFilterModal,
    setShowSavedFilterModal,
    editableFilterGroups,
    editableSavedFilter,
    onOpenNewModal,
    onOpenEditModal,
    onCloseModal
  }
}
